import { render, staticRenderFns } from "./Innovation.vue?vue&type=template&id=f6bbdb04&"
import script from "./Innovation.vue?vue&type=script&lang=js&"
export * from "./Innovation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports